import moment from 'moment';

import './styles.scss'
import {IShipmentsPerDay} from '../../../api/ShipmentsPerDay/ShipmentsPerDay.types';
import {IWidgetResponse} from '../../../api/Base/Base.types'
import {ResponsiveLine} from "@nivo/line";
import {Stack, Text} from "@mantine/core";

interface Props {
    data?: IWidgetResponse<IShipmentsPerDay>
}

function ShipmentsPerDay({data}: Props) {
    function renderGraph() {
        if (data) {
            const curData = [{
                id: "ShipmentsPerDay",
                data: data.data.map(d => ({x: `${moment(d.departureDate).format("MM/DD/YYYY")}`, y: d.containerCount}))
            }]
            return (
                <ResponsiveLine
                    data={curData}
                    margin={{top: 10, right: 20, bottom: 10, left: 60}}
                    xScale={{type: 'point'}}
                    curve="monotoneX"
                    colors="#6CADD9"
                    yScale={{
                        type: 'linear',
                        min: 0,
                        max: 'auto',
                    }}
                    axisTop={null}
                    axisRight={null}
                    axisBottom={null}
                    axisLeft={{
                        orient: 'left',
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'Container Count',
                        legendOffset: -40,
                        legendPosition: 'middle'
                    } as any}
                    pointSize={5}
                    pointColor={{theme: 'background'}}
                    pointBorderWidth={2}
                    pointBorderColor={{from: 'serieColor'}}
                    pointLabelYOffset={-12}
                    enableArea={true}
                    enableSlices="x"
                    useMesh={true}
                    sliceTooltip={({slice}) => {
                        return (
                            <div
                                style={{
                                    background: 'white',
                                    padding: '9px 12px',
                                    border: '1px solid #ccc',
                                }}
                            >
                                {slice.points.map(point => (
                                    <div
                                        key={point.id}
                                        style={{
                                            padding: '3px 0',
                                        }}
                                    >
                                        <div>Date: <strong>{point.data.xFormatted}</strong></div>
                                        <div>{point.serieId}: <strong>{point.data.yFormatted}</strong></div>
                                    </div>

                                ))}
                            </div>
                        )
                    }}
                />
            )
        } else {
            return (
                <Stack align="center">
                    <Text>No Data Found</Text>
                </Stack>
            )
        }
    }

    return (
        <div className="widget-nivo-base">
            <div className='header'>
                <Text>
                    Shipments Per Day
                </Text>
            </div>
            <div className='widget-chart-container'>
                {renderGraph()}
            </div>
        </div>
    )
}

export default ShipmentsPerDay;